import taskDraftSir from '../../../../assets/img/newlookahead/sir/draftSirIcon.svg';
import taskDraftSir2 from '../../../../assets/img/newlookahead/sir/draftSirIcon2.svg';
import taskPendingSir from '../../../../assets/img/newlookahead/sir/taskPending.svg';
import activitiesEvents from '../actions/events/activities';

const UNFIT_END_MESSAGES = {
  early: (t) => t('early_end_conflict'),
  late: (t) => t('late_end_conflict'),
  pending: (t) => t('task_pending_sir_tooltip'),
  send: (t) => t('task_draft_sir_tooltip'),
  roleOutPermis: (t) => t('not_permissions_actions')
};

export const getClassOdd = (task, column) => {
  let isOdd = false;
  if (
    window.ganttVisualization?.oddColsConfig &&
    task?.type === 'activitytask'
  ) {
    isOdd = window.ganttVisualization.oddColsConfig[column.name];
  }
  return isOdd ? 'odd-col' : 'non-odd-col';
};

export const setUpModificationRequest = ({ onlyRead }) => {
  if (
    !window.ganttVisualization?.lookaheadTemplates_actionActivityModification
  ) {
    window.ganttVisualization.lookaheadTemplates_actionActivityModification = (
      taskId
    ) => {
      if (!onlyRead && getCurrentUserRole() !== 'subtrade') {
        const currentTask = window.ganttVisualization.getTask(taskId);
        const currentTaskParent = window.ganttVisualization.getTask(
          currentTask?.activityReference?.id
        );

        if (!currentTaskParent) {
          return;
        }

        if (
          currentTask?.modificationSource === 'draft' &&
          currentTaskParent?.requestState === 'pending'
        ) {
          return;
        }

        activitiesEvents.openScheduleImpactRequestModal(
          currentTaskParent?.id,
          'calendar_icon_task'
        );
      }
    };
  }
};

export const calculateUnfitTooltipData = (task, t) => {
  let tooltip = '';
  const role = getCurrentUserRole();
  const roleOutPermis = ['subtrade', 'lastplanner', 'manager'].includes(role);
  const activityCurrent = window.ganttVisualization.getTask(
    task.activityReference?.id
  );
  const iconToShow = getIcon(task, activityCurrent);

  if (task.unfitEndDate) {
    const getMessage = UNFIT_END_MESSAGES[task.unfitEndDate];
    tooltip = getMessage ? getMessage(t) : '';
  }
  if (task.modificationSource === 'pending' && task.unfitEndDate) {
    tooltip = UNFIT_END_MESSAGES['pending'](t);
  }
  if (
    activityCurrent.requestState === 'pending' &&
    task.modificationSource !== 'pending'
  ) {
    tooltip = UNFIT_END_MESSAGES['send'](t);
  }

  if (roleOutPermis) {
    tooltip = UNFIT_END_MESSAGES['roleOutPermis'](t);
  }

  return {
    tooltip,
    iconToShow,
    isVisible: Boolean(task.unfitEndDate),
    unfitType:
      task.unfitEndDate ||
      (task.activityReference?.requestState === 'pending' ? 'pending' : '')
  };
};

const getIcon = (task, activityCurrent) => {
  if (task.modificationSource === 'pending' && task.unfitEndDate) {
    return taskPendingSir;
  }
  if (activityCurrent?.requestState === 'pending') {
    return taskDraftSir2;
  }
  return taskDraftSir;
};

/**
 * Formats a date according to the format specified in window.ganttVisualization.currentDateFormat.
 * This implementation replaces moment.js with native JavaScript methods to improve performance,
 * especially in high-frequency operations like Gantt chart scrolling.
 *
 * Supported formats:
 * - MM/DD/YY     -> "12/23/24"
 * - DD/MM/YY     -> "23/12/24"
 * - MM/DD/YYYY   -> "12/23/2024"
 * - DD/MM/YYYY   -> "23/12/2024"
 * - MM/DD/YY HH:mm -> "12/23/24 16:00"
 * - DD/MM/YY HH:mm -> "23/12/24 16:00"
 *
 * @param {Date|string} date - Date to format. Can be a Date object or a string in format
 *                            "Mon Dec 23 2024 16:00:00 GMT+0100 (Central European Standard Time)"
 *
 * @returns {string} Date formatted according to window.ganttVisualization.currentDateFormat
 *                   If no format is specified, defaults to 'MM/DD/YY'
 *
 * @example
 * // If window.ganttVisualization.currentDateFormat is "MM/DD/YY"
 * formatDate("Mon Dec 23 2024 16:00:00 GMT+0100") // returns "12/23/24"
 *
 * @example
 * // If window.ganttVisualization.currentDateFormat is "DD/MM/YY HH:mm"
 * formatDate("Mon Dec 23 2024 16:00:00 GMT+0100") // returns "23/12/24 16:00"
 *
 * @performance This implementation is more efficient than moment.js because:
 * 1. Uses native JavaScript methods (Date)
 * 2. Doesn't load a 300KB external library
 * 3. Performs fewer operations for formatting
 * 4. Better suited for high-frequency operations
 */
export const formatDate = (date) => {
  if (!date) return '';

  const d = new Date(date);
  if (isNaN(d.getTime())) return '';

  const format =
    window.ganttVisualization?.currentDateFormat?.replace('hh', 'HH') ||
    'MM/DD/YY';

  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const day = d.getDate().toString().padStart(2, '0');
  const year = d.getFullYear();
  const shortYear = year.toString().slice(-2);

  const firstPart = format.startsWith('DD')
    ? `${day}/${month}`
    : `${month}/${day}`;

  const secondPart = format.includes('YYYY') ? year : shortYear;

  const timePart = format.includes('HH:mm')
    ? ` ${d.getHours().toString().padStart(2, '0')}:${d
        .getMinutes()
        .toString()
        .padStart(2, '0')}`
    : '';

  return `${firstPart}/${secondPart}${timePart}`;
};

export const getEndDateClass = (task) => {
  if (!task.unfitEndDate && !task.unfitStartDate) return '';
  return task.modificationSource === 'pending'
    ? 'end-date-pending'
    : 'end-date-draft';
};

export const getCurrentUserRole = () => {
  const user = JSON.parse(localStorage.getItem('user'));

  return user?.role;
};
